import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";
// import { getPopmenuInfo } from '@/api/base'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'
// import Delivery from "./delivery";
// import ModalView from '@/components/modal-view'
import OpenApp from '../../components/OpenApp';
// import { saveAddrInfo, getAddrInfo } from '@/api/user-new'
import { connect } from 'react-redux';
import { Toast } from "antd-mobile";
import h5Share from '@/utils/h5Share'
import Modal from './modal'
import {fetchOrderOne} from './api'
import { handleUploadTrace } from '@/utils'
import { jumpTo } from '@/utils'
// import { ModalContainer } from "../sku-exchange/style";
const Active_151 = ({token}) => {
  const active_id =  151;

  const modelRef = useRef('');
    const [orderId,setOrderId] = useState('');
    
  const isStorm = bwmodel.app === 'storm';
 

  useEffect(() => {
    document.title = '8节课打造高胜算交易体系';
    handleUploadTrace('ActivityPagelyuan')

    h5Share.main({
      title: `8节课打造高胜算交易体系`,
      desc: '从新手到高手的交易体系',
      link: process.env.REACT_APP_DEMAND_URL + 'active_'+ active_id,
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();

  }, [])



  const handleLeftClick = () => {
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    // }
  }

  const linkToDownload = () => {
    // 埋点
    // handleUploadTrace('7th-anniversary_link-download', 'click')
    //
    window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }


  const handleUnlock = () => {  //
    // if(!showPopMenu) {
    //   return Toast.info('活动已经结束')
    // }
    // 埋点
    // if (source === 'mini') {
    //   /* eslint-disable no-undef */
    //   wx.miniProgram.navigateTo({url: '/pages/kefu/index'})
    //   return
    // }
    if (!isStorm) {
      linkToDownload()
      return
    }
    if (!token) {
      handleLogin()
      return
    }
    if(orderId) {
     return jumpTo(`/active_151/code?id=${orderId}`)
    }
    const goods  = {
      skuPrice: 99,
      // skuPrice: 0.01,
      skuId: 166,
      goodsName: '大鳄周边',  // 此地写死，如复制需要注意
      spuId: '28'     // 此地写死，如复制需要注意
    }

    bridge.callHandler('nativeEvent', {
      event: 'halfScreenPay',
      params: {
        price: `${goods.skuPrice}`,
        activityTitle: goods.goodsName,
        skuId: `${goods.skuId}`,
        orderType: `${goods.spuId}`
      },
    }, (params) => {
      try {
        const info = JSON.parse(params)
        if (info && info.params.result) {

          initPage(true)

          // bridge.callHandler('nativeEvent', {event: 'close', params: {
          //   isDelete: false
          // }}, () => {})
        } else {
          //
          // Toast.info('支付失败，遇到问题可「意见反馈」联系我们')
        }
      } catch (error) {
        //
      }
    })
  }
  useEffect(() => { 
   initPage()
  }, [])
 function initPage(bool) { 
    // bool 值是否跳转到 客服
   const params = {
      "orderType": 28,
      "skuId": 166,
      "spuCategory": 1,
      "state": 2,
      "totalAmount": "99.00",
      //  "totalAmount": "0.01"
    }

    fetchOrderOne(params)
      .then(res => {
        console.log(res)
        if (res.data) {
        
          setOrderId(res.data.orderId)
          if (bool) {
            return jumpTo(`/active_174/code?id=${res.data.orderId}`)
          }
          //  return jumpTo(`/active_151/code?id=${res.data.orderId}`)
        }
      })
  }
 
  function  copyTextToClipboard() {
    // try {
    //    navigator.clipboard.writeText(orderId);
    //     // console.info('文本已复制到剪贴板');
    //     Toast.info('复制成功')
    // } catch (err) {
    //     console.error('复制失败', err);
    // }
     var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = orderId;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
              Toast.info('复制成功')
}

  function handleScroll(e) {
    // let footer = document.getElementById('footer');

    // if(footer) {
    //   if(window.scrollY >=20) {
    //     footer.classList.add('footer-freeclass-block');
    //   }else {
    //     footer.classList.remove('footer-freeclass-block');
    //   }
    // }

  }



  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
  }, [])

  return (
    <div>
      {
        isStorm && <Header
          title={'8节课打造高胜算交易体系'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
           right={
              bwmodel.compareVersion('4.17.9') ?( <img
              onClick={()=> {
                bridge.callHandler('nativeEvent', {
                    event: 'shareLink',
                    params: {
                      // shareLinkParams:{
                      title: `8节课打造高胜算交易体系`,
                      desc: '从新手到高手的交易体系',
                      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_151',
                    }
                  })
              }}
              style={{width:'20px','vertical-align': 'middle'}}
              src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)}
              alt="分享"
            />
              )
          :''
            }
        />
      }

      <Container style={{marginTop: isStorm?'44px':'0px'}}>
       {/* <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" /> */}
        {/* <img className="member-img" src={require('./img/Slice1@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice2@2x.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice3@2x.png')} alt="市值风云" /> */}

        <img className="member-img" src={require('./img/Slice4.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice5.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice6.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice7.png')} alt="市值风云" />
        <img className="member-img" src={require('./img/Slice8.png')} alt="市值风云" />
      <div className="footer footer-freeclass-block" id="footer">
     
        <div className="btn" 
          onClick={()=>{
            handleUnlock()
          }
          }
        >
          {/* {orderId} */}
          {
            orderId ?   <img src={require('./img/Group_1000006766.png')} alt=""/> :
              <img src={require('./img/Group_1000006768.png')} alt=""/>
          }
        
        </div>
        {
          orderId ? <div class='tips2'> 订单号：{orderId} <span className="copy" onClick={()=>{
            copyTextToClipboard()
          }}>复制</span></div>:
             <div class='tips2'> 订阅成功后，将前往微信学习课程</div> 
        }
        {/* <div class='tips2'> {orderId ? '订阅成功后，将前往微信学习课程':'订阅成功后，将前往微信学习课程'}</div> */}
      </div>
   
   
      </Container>
        <Modal ref={modelRef}/>
        {/* <Delivery visible={deliveryVisible} ref={deliveryRef} onClose={() => setDeliveryVisible(false)} onSubmit={handleSubmitAddr} activityId={active_id} /> */}
        {
          !isStorm && <OpenApp style={{marginBottom: '20px'}}  url={`${process.env.REACT_APP_DEMAND_URL}active_150`}></OpenApp>
        }
    </div>
  )
}


const Container = styled.div`
// backkground-image:lwebkit-linear-gradient(top,##FFEFC2,#ffffff);
// background: linear-gradient( 180deg, #FFEFC2 0%, #FFFFFF 100%);
background: #FFEFC2;
padding-bottom:66px;
img {
  vertical-align: middle;
  font-size:0;
  width:100%;
}
 .first {
  margin-bottom: -37vw;
 }
  .member-img {
    box-sizing: border-box;
  }
    .footer {
      // height: 96px;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
      padding: 10px 4.1vw 10px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: -126px;
      z-index: 10;
      transition: bottom 0.5s;
      &.footer-freeclass-block {
        bottom: 0;
      }
      .tips{
        padding: 10px;
        color: #FFF;
        text-align:center;
       
      }
      .copy {
        height: 22px;
        font-family: OPPO Sans 4.0, OPPO Sans 40;
        font-weight: 500;
        font-size: 16px;
        color: #621818;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: #FFF3E0;
        display: inline-block;
        padding: 0 10px;
        transform: scale(0.5);
      }
       .tips2 {
        text-align: center;
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 13px;
        margin-top: 10px;
        color: #262626;
      }
      .btn {
        margin: 0 auto;
        width: 80vw;
        height: 48px;
        background: #fff;
        border-radius: 25px;
        font-size: 16px;
        color: #F8203A;
        text-align: center;
        position: relative;
        img {
          height: 48px;
        }
     
        .tips {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 10px;
          padding: 0px;
          line-height: 14px;
          color: #F8203A;
        
        }
        >span {
          position: absolute;
          right: 0px;
          width: 70px;
          height: 20px;
          border-radius: 8px 8px 8px 0px;
          color: #FFFFFF;
          background: #F3BB6D;
          text-decoration: line-through;
          top: -10px;
          font-size:12px;
          line-height: 17px;
        }
      }
    }
@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}

.fixed_box {
  position: fixed;
  bottom: 120px;
  width: 48px;
  right: 10px;
}
`
// const ModalContainer = styled.div`
//   .modalCon {
//       position: relative;
//       img {
//         width:68.2vw;
//       }

//   }
//   .tips {
//     color: #FFFFFF;
//     position: absolute;
//     width:100%;
//     text-align:center;
//     top: 31vw;
//   }
//   .close {
//     display: block;
//     margin: 10px auto 0;
//   }
// `

// const ModalView =  styled.div`
//   position: fixed;
//   left: 0;
//   top: 0;
//   overflow: hidden;
//   width: 100%;
//   height: 100%;
//   z-index: 1000;
//   display: inline-block;
//   .bg {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0,0,0,0.5);
//     z-index: 10;
//   }
//   .con {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 11;
//   }

// `


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_151))




// WEBPACK FOOTER //
// ./src/views/activity_151/index.js